import { RouteRecordRaw } from 'vue-router';


export const subcontractorRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'subcontractor-layout',
    component: () => import('@/layouts/CarrierLayout.vue'),
    meta: {
      requiresAuth: true,
      tenant_type: ['subcontractor'],
    },
    children: [
      {
        path: '',
        name: 'default-carrier',
        redirect: '/dashboard',
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/pages/subcontractor/dashboard/Dashboard.vue'),
        meta: {
          title: 'dashboard',
        },
      },
      {
        path: 'onboarding',
        name: 'onboarding',
        component: () => import('@/pages/subcontractor/onboarding/OnboardingPortalPage.vue'),
        meta: {
          title: 'Onboarding',
        },
      },
      {
        path: 'drivers',
        name: 'drivers',
        component: () => import('@/pages/drivers/DriversPage.vue'),
        meta: {
          title: 'Drivers',
        },
      },
      {
        path: 'drivers/calendar-overview',
        name: 'calendar-overview',
        component: () => import('@/pages/drivers/components/CalendarOverview.vue'),
        meta: {
          title: 'Calendar Overview',
        },
      },
      {
        path: 'driver/:id',
        name: 'driver',
        component: () => import('@/pages/drivers/DriverDetailPage.vue'),
        meta: {
          title: 'Driver Detail',
        },
      },
      {
        path: 'fleet',
        name: 'fleet',
        component: () => import('@/pages/fleet/FleetPage.vue'),
        meta: {
          title: 'Fleet',
        },
      },
      {
        path: 'fleet/trailer-detail/:id',
        name: 'trailer-detail',
        component: () => import('@/pages/fleet/components/TrailerDetail.vue'),
        meta: {
          title: 'Trailer Detail',
        },
      },
      {
        path: 'fleet/truck-detail/:id',
        name: 'truck-detail',
        component: () => import('@/pages/fleet/components/TruckDetail.vue'),
        meta: {
          title: 'Truck Detail',
        },
      },
      {
        path: 'fleet/templates-editor',
        name: 'templates-editor',
        component: () => import('@/pages/fleet/components/templates-editor/TenantTemplatesEditor.vue'),
        meta: {
          title: 'Templates Manager',
        },
      },
      {
        path: 'check-reports',
        name: 'check-reports',
        component: () => import('@/pages/check-report/CheckReportPage.vue'),
        meta: {
          title: 'Check Reports',
        },
      },
      {
        path: 'users',
        component: () => import('@/pages/users/UsersView.vue'),
      },
      {
        path: 'users/calendar-overview',
        component: () => import('@/pages/users/StaffHolidayPage.vue'),
      },
      {
        path: 'users/:id',
        component: () => import('@/pages/users/UserDetailPage.vue'),
      },
      {
        path: 'chat',
        component: () => import('@/pages/chat/ChatPage.vue'),
      },
      {
        path: 'chat-groups',
        component: () => import('@/pages/chat-groups/ChatGroupsView.vue'),
      },
      {
        path: 'timesheet',
        name: 'timesheet',
        component: () => import('@/pages/timesheet/TimesheetPage.vue'),
        meta: {
          title: 'Timesheet',
        },
      },
      {
        path: 'invoices',
        name: 'invoices',
        component: () => import('@/pages/subcontractor/invoices/InvoicesPage.vue'),
        meta: {
          title: 'Invoices',
        },
      },
      {
        path: 'trips',
        name: 'trips',
        component: () => import('@/pages/subcontractor/trips/TripsSubcontractorView.vue'),
        meta: {
          title: 'Trips',
        },
      },
      {
        path: 'trip-documents/:vrid',
        name: 'trip-documents',
        component: () => import('@/pages/trip-documents/TripDocumentsPage.vue'),
        meta: {
          title: 'Trip Documents',
        },
      },
      {
        path: 'fuel-cards',
        name: 'fuel-cards',
        component: () => import('@/pages/fuel-cards/FuelCardsView.vue'),
        meta: {
          title: 'Fuel Cards',
        },
      },
      {
        path: 'fuel',
        name: 'fuel',
        component: () => import('@/pages/fuel/FuelView.vue'),
        meta: {
          title: 'Fuel',
        },
      },
      {
        path: 'defect',
        name: 'defect',
        component: () => import('@/pages/defects/DefectView.vue'),
        meta: {
          title: 'Defect',
        },
      },
      {
        path: 'audit-logs',
        name: 'audit-logs-subcontractor',
        component: () => import('@/pages/audit-logs/AuditLogsPage.vue'),
        meta: {
          title: 'Audit Logs',
        },
      },
      {
        path: 'note',
        name: 'note',
        component: () => import('@/pages/notes/NotePage.vue'),
        meta: {
          title: 'Note',
        },
      },
      {
        path: 'user-profile',
        name: 'user-profile',
        component: () => import('@/pages/user-profile/UsersProfileView.vue'),
        meta: {
          title: 'User Profile',
        },
      },
      {
        path: 'company-profile',
        name: 'company-profile',
        component: () => import('@/pages/company-profile/CompanyProfilePage.vue'),
        meta: {
          title: 'Company Profile',
        },
      }
    ],
  },
];
